var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-up",attrs:{"name":"sign-up"}},[(_vm.step === 0)?_c('agreement',{on:{"next":_vm.next}}):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('input-phone',{on:{"back":_vm.back}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63594d1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/showcase/SignUp.vue
// module id = null
// module chunks = 